import { Note } from '@lyrahealth-inc/shared-app-logic/src/models/notes/Notes'

// A general note is titled by its subject. Templates without a subject field (like the NP Async Time
// Note) use the template title instead.
export const getGeneralNoteTitle = (note: Pick<Note, 'body' | 'content_meta_data'>): string => {
  const subject = note.body?.subject
  return (typeof subject === 'string' && subject) || note.content_meta_data?.title || ''
}
